import { FC, useCallback, useEffect, useState } from 'react';
import { useDialog, useSideMenu } from '@/logic/state';

import { ConfirmDialog } from '../shared/confirm-dialog';
import shallow from 'zustand/shallow';

const ChangeCityImage = '/icons/dialog/change-city-image.svg';

const defaultDescription = 'change_city_confirm_dialog.description';
export const ChangeCityConfirmDialog: FC = () => {
  const [dialog, setDialog] = useDialog(s => [s.dialog, s.setDialog], shallow);
  const setSideMenu = useSideMenu(s => s.setSideMenu, shallow);
  const [description, setDescription] = useState<string>(defaultDescription);

  const handleOkayClick = useCallback(() => {
    setSideMenu(false);
    dialog?.changeCityConfirmDialogPayload?.handleOkayClick();
  }, [dialog?.changeCityConfirmDialogPayload, setSideMenu]);

  useEffect(() => {
    setDescription(
      dialog?.changeCityConfirmDialogPayload?.description || defaultDescription
    );
  }, [dialog?.changeCityConfirmDialogPayload]);

  return (
    <ConfirmDialog
      buttonId='change-city-confirm-dialog'
      img={ChangeCityImage}
      widthImage='66px'
      heightImage='74px'
      altImage='alt.change_city_image'
      title='change_city_confirm_dialog.title'
      description={description}
      handleOkayClick={handleOkayClick}
      handleCloseClick={() => setDialog({})}
    />
  );
};
